import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";

import { LgdCheckboxModule, LgdDatePickerModule, LgdNumberModule, LgdSelectModule, LgdTextModule } from "@tylertech/lgd-reactive-forms";
import { CoreModule } from "@tylertech/core-module";
import { UserDefinedFieldService, UserDefinedFieldsDialogsService } from "./services";
import { CommandsModule } from "@tylertech/commands-module";
import
{
    UserDefinedFieldComponent,
    UserDefinedFieldListComponent,
    UserDefinedFieldMenuComponent,
    UserDefinedFieldsDialogComponent,
} from "./components/userDefinedFields";

const angularModules = [
    CommonModule,
    FlexModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
];

const angularMaterialModules = [
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule
];

const lgdModules = [
    CoreModule,
    LgdCheckboxModule,
    LgdDatePickerModule,
    LgdNumberModule,
    LgdSelectModule,
    LgdTextModule,
    CommandsModule,
];

const components = [
    UserDefinedFieldMenuComponent,
    UserDefinedFieldListComponent,
    UserDefinedFieldComponent,
    UserDefinedFieldsDialogComponent
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules,
    ],
    declarations: components,
    exports: components,
    providers: [
        UserDefinedFieldService,
        UserDefinedFieldsDialogsService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserDefinedFieldsModule { }
